export const getNestedError = (errors: unknown, path: string): { message?: string } | undefined => {
  const parts = path.split('.');
  let current: unknown = errors;

  for (const part of parts) {
    if (current && typeof current === 'object' && part in current) {
      current = (current as Record<string, unknown>)[part];
    } else {
      return undefined;
    }
  }

  return current as { message?: string } | undefined;
};
